import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    slideshowWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', maxWidth: '1200px', margin: 'auto' },
    slideshowContainer: { maxWidth: '1000px', position: 'relative', flex: '1' },
    mySlidesHide: { display: 'none', animationName: 'fade', animationDuration: '1.5s' },
    mySlidesShow: { display: 'block', animationName: 'fade', animationDuration: '1.5s' },
    fade: {},
    numberText: { color: '#1D2130', fontSize: '12px', padding: '8px 12px', position: 'absolute', top: 0 },
    text: {
        color: '#1D2130',
        fontSize: '15px',
        padding: '8px 12px',
        position: 'absolute',
        bottom: '8px',
        width: '100%',
        textAlign: 'center',
    },
    prev: {
        cursor: 'pointer',
        padding: '16px',
        fontWeight: 'bold',
        fontSize: '18px',
        transition: '0.6s ease',
        borderRadius: '3px',
        userSelect: 'none',
        minWidth: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
    },
    next: {
        cursor: 'pointer',
        padding: '16px',
        fontWeight: 'bold',
        fontSize: '18px',
        transition: '0.6s ease',
        userSelect: 'none',
        borderRadius: '3px',
        minWidth: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
    },
}));

const SlideShow = ({ slideElements, enableZoom = false }) => {
    const [slideIndex, setSlideIndex] = React.useState(0);
    const [showZoomed, setShowZoomed] = React.useState(false);
    const [loadedFullImages, setLoadedFullImages] = React.useState({});
    const classes = useStyles();

    const onNext = (event) => {
        if (slideIndex + 1 >= slideElements.length) {
            setSlideIndex(0);
        } else {
            setSlideIndex(slideIndex + 1);
        }
        event.preventDefault();
        event.stopPropagation();
    };

    const onPrev = (event) => {
        if (slideIndex - 1 < 0) {
            setSlideIndex(slideElements.length - 1);
        } else {
            setSlideIndex(slideIndex - 1);
        }
        event.preventDefault();
        event.stopPropagation();
    };

    useEffect(() => {
        setSlideIndex(0);
    }, [slideElements]);

    const zoomImage = (index) => {
        if (enableZoom) {
            const element = slideElements[index];
            if (element.fullImg && !loadedFullImages[index]) {
                setLoadedFullImages({ ...loadedFullImages, [index]: element.fullImg });
            }
            setShowZoomed(true);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className={classes.slideshowWrapper}>
                {slideElements.length > 1 ? (
                    <a className={classes.prev} onClick={onPrev}>
                        ❮
                    </a>
                ) : null}
                <div className={classes.slideshowContainer}>
                    {slideElements.map((el, index) => {
                        return (
                            <div
                                className={index === slideIndex ? classes.mySlidesShow : classes.mySlidesHide}
                                key={`slide-show-${index}`}
                            >
                                {slideElements.length > 1 ? (
                                    <div className={classes.numberText}>
                                        {index + 1} / {slideElements.length}
                                    </div>
                                ) : null}
                                <img src={el.img} style={{
                                    width: '100%',
                                    verticalAlign: 'middle',
                                    cursor: el.onClick ? 'pointer' : (enableZoom ? 'zoom-in' : 'auto'),
                                }} onClick={() => el.onClick ? el.onClick() : zoomImage(index)} alt='zoom' />
                                <div className={classes.text}>{el.text ? el.text : ''}</div>
                            </div>
                        );
                    })}
                </div>
                {slideElements.length > 1 ? (
                    <a className={classes.next} onClick={onNext}>
                        ❯
                    </a>
                ) : null}
            </div>
            <Dialog onClose={() => {
                setShowZoomed(false);
            }} open={showZoomed} fullWidth={true} maxWidth={false}>
                <img src={loadedFullImages[slideIndex] || slideElements[slideIndex]?.fullImg || slideElements[slideIndex]?.img} style={{
                    width: '100%',
                    verticalAlign: 'middle',
                    cursor: enableZoom ? 'zoom-out' : 'auto',
                }} onClick={() => {
                    setShowZoomed(false);
                }} alt='back' />
            </Dialog>
        </div>
    );
};

export default SlideShow;
